module Eseebase {
    export interface IModelDetailScope extends ng.IScope {
        fileId: string;
        fileDetails: FileDetailsViewModel;
        updateScroll: Function;
        expandClick: Function;
        display: boolean;
        onExpand: Function;
    }

    export class ModelDetailDirective {
        public link: (scope: IModelDetailScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => void;
        public templateUrl = '/app/directives/model-detail.html';
        public scope = {
            fileId: '=',
            isSim: '=',
            onExpand: '&'
        };
        public restrict = 'E';
        public require: string;
        public replace: any;

        constructor($timeout: ng.ITimeoutService, $rootScope: ng.IRootScopeService, fileService: FileService) {
            ModelDetailDirective.prototype.replace = 'true';
            ModelDetailDirective.prototype.link = (scope: IModelDetailScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => {
                scope.$on('model-expand-collapse', (event, args) => {
                    if (args.fileId == scope.fileId) {
                        scope.display = !scope.display;
                        if (scope.display) {
                            element.find('.details').css('height', element.find('.detail-container').height() + 'px');
                            fileService.getDetails(scope.fileId).then((details: FileDetailsViewModel) => {
                                scope.fileDetails = details;
                            });
                        }
                        else {
                            element.find('.details').css('height', '0px');
                        }
                    }
                });
            }
        }

        public static Factory() {
            var directive = ($timeout: ng.ITimeoutService, $rootScope: ng.IRootScopeService, fileService: FileService) => {
                return new ModelDetailDirective($timeout, $rootScope, fileService);
            };

            directive['$inject'] = ['$timeout', '$rootScope', 'FileService'];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('modelDetail', ModelDetailDirective.Factory());
}